import { ActivityIndicator, StyleSheet, View } from "react-native";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { SignInForm } from "./SignInForm";
import { AppShell } from "./AppShell";
import { WebThemeProvider } from "./WebThemeProvider";
import { ThemeProfileBridge } from "./ThemeProfileBridge";
import { useThemePalette } from "./theme";

// web-rnw root. Switches on the shared AuthContext (copied verbatim from
// apps/web) between a sign-in form and the signed-in app shell. The shell
// holds the header + nav and renders the active surface (Programs for
// everyone, the admin feedback inbox for admins). State-based navigation,
// one surface at a time — see next/rnw-strangler.md.
function Root() {
  const { state } = useAuth();
  // Theme-aware root background + spinner (inside WebThemeProvider). Was a
  // hardcoded dark-only bg + drifted brand-orange spinner before theming.
  const { p } = useThemePalette();
  const screen = { flex: 1, backgroundColor: p.bg } as const;

  if (state.status === "loading") {
    return (
      <View style={[screen, styles.center]}>
        <ActivityIndicator color={p.brand500} />
      </View>
    );
  }

  if (state.status === "signed_in") {
    return (
      <View style={screen}>
        <ThemeProfileBridge />
        <AppShell user={state.user} />
      </View>
    );
  }

  // signed_out + needs_confirm both land on the sign-in form for the
  // scaffold (the confirm-code flow isn't ported to RNW yet).
  return (
    <View style={[screen, styles.center]}>
      <SignInForm />
    </View>
  );
}

export function App() {
  return (
    <WebThemeProvider>
      <AuthProvider>
        <Root />
      </AuthProvider>
    </WebThemeProvider>
  );
}

const styles = StyleSheet.create({
  center: { alignItems: "center", justifyContent: "center" },
});
